<template>
	<pagina-erro
		titulo="Página em construção"
		icone="fa fa-cog fa-spin"
		imagemTexto="centralservidor-logo-texto.png"
		imagem="centralservidor-logo.png"
		texto="A página que você está tentando acessar não foi construída ainda.
			Volte mais tarde, por favor." >
	</pagina-erro>
</template>

<script >
import PaginaErro from '@/components/pagina-erro'

export default {
	name: 'Construcao',
	components: {
		PaginaErro
	}
}
</script>




// WEBPACK FOOTER //
// index.vue?322a7212